import { render, staticRenderFns } from "./MultipleFileComponent.vue?vue&type=template&id=bf650776&scoped=true&"
import script from "./MultipleFileComponent.vue?vue&type=script&lang=js&"
export * from "./MultipleFileComponent.vue?vue&type=script&lang=js&"
import style0 from "./MultipleFileComponent.vue?vue&type=style&index=0&id=bf650776&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf650776",
  null
  
)

export default component.exports